import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d5394221: FaireBrandEntity = {
  token: "b_d5394221",
  type: "brand",
  name: "Honeybee Gardens Natural Cosmetics & Body Care",
  avatarUrl:
    "https://cdn.faire.com/fastly/969e58e488c560ec3ad3ac5bcde39928c660a485eca62c1673de4f2013c54c03.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c946f7161fa1b68c21e29eebff8f8e9b63cb495cc79891f2c11113f4bc6059c3.png",
  logoUrl:
    "https://cdn.faire.com/fastly/969e58e488c560ec3ad3ac5bcde39928c660a485eca62c1673de4f2013c54c03.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c946f7161fa1b68c21e29eebff8f8e9b63cb495cc79891f2c11113f4bc6059c3.png",
  location: "Leesport, PA, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 101,
  isInsider: true,
  description:
    "For 30 years, well before natural was just a fancy marketing term, Honeybee Gardens has been producing healthy, effective & affordable products for all. We're a proudly independent, woman-owned business crafting certified gluten free, vegan & cruelty free cosmetics & body care.  \n\nIn 1995, Melissa Buckley founded Honeybee Gardens. She took her vast knowledge of the herbs she was growing in her garden to produce safe and effective body care in her own kitchen for her loved ones. With each passing year she expanded her line of exquisitely crafted facial and body care items and then took the leap into color! As an early believer in cleaner beauty, Melissa led the charge to create more exciting color products in the bland world of natural cosmetics. \n\nNow, decades later, we're still providing our beloved customers with their original favorites but have expanded our line to over 150 skus! All of our growth has been our own. We're still privately-owned and operated by Melissa and her small, but mighty, team of dedicated women in eastern PA.\n\nWe continually strive to keep producing clean, fun, luxury feeling products at affordable-for-all price points. Thank you for coming along on this journey with us.  \n\nWelcome to our hive. We're so happy you're here.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:36.795Z",
    importedBy: "entity-db-cli",
  },
};
